var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idea-score-checkmark-text d-flex align-items-center"},[(_vm.text)?_c('p',{staticClass:"m-0 text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(_vm.hasTextSlot)?_c('div',{staticClass:"text"},[_vm._t("text")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }